import React, { useState } from "react";

import CatalogueNavbar from "./components/CatalogueNavbar";
import FooterCatalogue from "./components/FooterCatalogue";
export default function ProductPage() {
  // Product spec array start
  const [openDropdownIndex, setOpenDropdownIndex] = useState(null);

  const fabricData = [
    {
      iconUrl: "/icons_Products/Fabrics/FabricType.svg",
      topic: "Fabric Type",
      contentArray: ["100% cotton", "CVC", "T/C"],
    },
    {
      iconUrl: "/icons_Products/Fabrics/Size.svg",
      topic: "Size",
      contentArray: ["XS,S,M,L,XL,2XL,3XL,4XL"],
    },
    {
      iconUrl: "/icons_Products/Fabrics/MOQ.svg",
      topic: "Minimum Order Quantity",
      contentArray: ["300 kgs per colour"],
    },
    {
      iconUrl: "/icons_Products/Fabrics/OrderLead.svg",
      topic: "Order lead time",
      contentArray: ["7-15 working days."],
    },
    {
      iconUrl: "/icons_Products/Fabrics/PPSample.svg",
      topic: "PP Sample Lead Time",
      contentArray: ["15days"],
    },
    {
      iconUrl: "/icons_Products/Fabrics/Sample.svg",
      topic: "Sample making",
      contentArray: ["Yes, available for free."],
    },
    {
      iconUrl: "/icons_Products/Fabrics/Customize.svg",
      topic: "Customization",
      contentArray: ["Yes"],
    },
    {
      iconUrl: "/icons_Products/Fabrics/Blends.svg",
      topic: "Possible Blends",
      contentArray: ["Cotton", "Cotton + Lycra", "Polyester + Cotton"],
    },
    {
      iconUrl: "/icons_Products/Fabrics/BulkLead.svg",
      topic: "Bulk Lead Time",
      contentArray: ["60 days"],
    },
    {
      iconUrl: "/icons_Products/Fabrics/Branding.svg",
      topic: "Pattern and brand log",
      contentArray: ["Customized"],
    },
  ];

  const toggleDropdown = (index) => {
    setOpenDropdownIndex(openDropdownIndex === index ? null : index);
  };
  // Product spec array end

  // More about the fabric start
  const array = [
    {
      Image: "/fabrics/Mercerized-Cotton-Knit-Fabric4.png",
      Content: (
        <div className="text-left text-lg flex flex-col">
          <div className="mt-2 mb-3 text-[#242424] ">
            The Unique Texture of Pique Knit Fabric
          </div>
          <div className="mt-2 text-left mb-3 text-[#5B5B5B]">
            Pique knit fabric is characterized by its raised, textured surface,
            which is achieved through a specialized knitting technique. The
            raised patterns can vary, including small geometric shapes,
            waffle-like designs, or honeycomb patterns. This textured appearance
            sets pique fabric apart.
          </div>
        </div>
      ),
    },
    {
      Image: "/fabrics/Mercerized-Cotton-Knit-Fabric4.png",
      Content: (
        <div className="text-left text-lg flex flex-col">
          <div className="mt-2 mb-3 text-[#242424] ">
            The Unique Texture of Pique Knit Fabric
          </div>
          <div className="mt-2 text-left mb-3 text-[#5B5B5B]">
            Pique knit fabric is characterized by its raised, textured surface,
            which is achieved through a specialized knitting technique. The
            raised patterns can vary, including small geometric shapes,
            waffle-like designs, or honeycomb patterns. This textured appearance
            sets pique fabric apart.
          </div>
        </div>
      ),
    },
    {
      Image: "/fabrics/Mercerized-Cotton-Knit-Fabric4.png",
      Content: (
        <div className="text-left text-lg flex flex-col">
          <div className="mt-2 mb-3 text-[#242424] ">
            The Unique Texture of Pique Knit Fabric
          </div>
          <div className="mt-2 text-left mb-3 text-[#5B5B5B]">
            Pique knit fabric is characterized by its raised, textured surface,
            which is achieved through a specialized knitting technique. The
            raised patterns can vary, including small geometric shapes,
            waffle-like designs, or honeycomb patterns. This textured appearance
            sets pique fabric apart.
          </div>
        </div>
      ),
    },
    {
      Image: "/fabrics/Mercerized-Cotton-Knit-Fabric4.png",
      Content: (
        <div className="text-left text-lg flex flex-col">
          <div className="mt-2 mb-3 text-[#242424] ">
            The Unique Texture of Pique Knit Fabric
          </div>
          <div className="mt-2 text-left mb-3 text-[#5B5B5B]">
            Pique knit fabric is characterized by its raised, textured surface,
            which is achieved through a specialized knitting technique. The
            raised patterns can vary, including small geometric shapes,
            waffle-like designs, or honeycomb patterns. This textured appearance
            sets pique fabric apart.
          </div>
        </div>
      ),
    },
    // More items can be added here
  ];
  // More about the fabric end

  // Fabric composition start
  const contentArray = [
    {
      imageUrl:
        "https://www.shutterstock.com/shutterstock/photos/2456036585/display_1500/stock-photo-medicine-development-laboratory-asian-female-scientist-using-microscope-analyzes-petri-dish-2456036585.jpg",
      content: (
        <div className="text-center flex flex-col">
          <div>60%Polyester 36%Cotton</div>
          <div>4%Spandex Elastane</div>
          <div>Pique Knit Fabric 155cm</div>
        </div>
      ),
    },
    {
      imageUrl:
        "https://www.shutterstock.com/shutterstock/photos/2456036585/display_1500/stock-photo-medicine-development-laboratory-asian-female-scientist-using-microscope-analyzes-petri-dish-2456036585.jpg",
      content: (
        <div className="text-center flex flex-col">
          <div>60%Polyester 36%Cotton</div>
          <div>4%Spandex Elastane</div>
          <div>Pique Knit Fabric 155cm</div>
        </div>
      ),
    },
    {
      imageUrl:
        "https://www.shutterstock.com/shutterstock/photos/2456036585/display_1500/stock-photo-medicine-development-laboratory-asian-female-scientist-using-microscope-analyzes-petri-dish-2456036585.jpg",
      content: (
        <div className="text-center flex flex-col">
          <div>60%Polyester 36%Cotton</div>
          <div>4%Spandex Elastane</div>
          <div>Pique Knit Fabric 155cm</div>
        </div>
      ),
    },
    {
      imageUrl:
        "https://www.shutterstock.com/shutterstock/photos/2456036585/display_1500/stock-photo-medicine-development-laboratory-asian-female-scientist-using-microscope-analyzes-petri-dish-2456036585.jpg",
      content: (
        <div className="text-center flex flex-col">
          <div>60%Polyester 36%Cotton</div>
          <div>4%Spandex Elastane</div>
          <div>Pique Knit Fabric 155cm</div>
        </div>
      ),
    },
    {
      imageUrl:
        "https://www.shutterstock.com/shutterstock/photos/2456036585/display_1500/stock-photo-medicine-development-laboratory-asian-female-scientist-using-microscope-analyzes-petri-dish-2456036585.jpg",
      content: <p className="text-center">Description for Image 2</p>,
    },
    {
      imageUrl:
        "https://www.shutterstock.com/shutterstock/photos/2456036585/display_1500/stock-photo-medicine-development-laboratory-asian-female-scientist-using-microscope-analyzes-petri-dish-2456036585.jpg",
      content: <p className="text-center">Description for Image 2</p>,
    },
    {
      imageUrl:
        "https://www.shutterstock.com/shutterstock/photos/2456036585/display_1500/stock-photo-medicine-development-laboratory-asian-female-scientist-using-microscope-analyzes-petri-dish-2456036585.jpg",
      content: <p className="text-center">Description for Image 2</p>,
    },
    {
      imageUrl:
        "https://www.shutterstock.com/shutterstock/photos/2456036585/display_1500/stock-photo-medicine-development-laboratory-asian-female-scientist-using-microscope-analyzes-petri-dish-2456036585.jpg",
      content: <p className="text-center">Description for Image 2</p>,
    },
  ];

  // Fabric composition end

  // Discover more start
  const contentArray1 = [
    {
      imageUrl:
        "https://www.shutterstock.com/shutterstock/photos/2456036585/display_1500/stock-photo-medicine-development-laboratory-asian-female-scientist-using-microscope-analyzes-petri-dish-2456036585.jpg",
      content: <p className="text-center">Description for Image 2</p>,
    },
    {
      imageUrl:
        "https://www.shutterstock.com/shutterstock/photos/2456036585/display_1500/stock-photo-medicine-development-laboratory-asian-female-scientist-using-microscope-analyzes-petri-dish-2456036585.jpg",
      content: <p className="text-center">Description for Image 2</p>,
    },
    {
      imageUrl:
        "https://www.shutterstock.com/shutterstock/photos/2456036585/display_1500/stock-photo-medicine-development-laboratory-asian-female-scientist-using-microscope-analyzes-petri-dish-2456036585.jpg",
      content: <p className="text-center">Description for Image 2</p>,
    },
    {
      imageUrl:
        "https://www.shutterstock.com/shutterstock/photos/2456036585/display_1500/stock-photo-medicine-development-laboratory-asian-female-scientist-using-microscope-analyzes-petri-dish-2456036585.jpg",
      content: <p className="text-center">Description for Image 2</p>,
    },
  ];
  // Discover more end

  return (
    <div>
      <CatalogueNavbar />
      {/* Banner start */}
      <div
        className="h-[50vh] bg-cover bg-center relative"
        style={{ backgroundImage: "url('/FabCatbanner.png')" }}
      >
        {/* Inner div positioned at the bottom left corner */}
        <div className="absolute bottom-[7vh] md:bottom-[10vh] left-[5vh] md:left-[10vh] p-3 text-white text-4xl ">
          {/* Inner content here */}
          <p>
            <span className="font-bold text-2xl md:text-5xl">
              Ready To Wear
            </span>
          </p>
        </div>
      </div>
      {/* Banner end */}
      <div className="p-10 ">
        {/* Image Gallery start */}
        <div className="relative h-auto  flex md:flex-row flex-col  ">
          {/* Left Column (45% width) */}
          <div className="hidden   md:block md:w-[45%]">
            <ImageGallery />
          </div>
          <div className="block md:hidden md:w-[45%]">
            <ImageGallery1 />
          </div>
          {/* Right Column (55% width) - content placeholder */}
          <div className="w-full md:w-[55%] md:pt-0 pt-3 pl-0 md:pl-8 ">
            <h2 className="text-xl  mb-2">Mercerized Garment Knit Fabric</h2>
            <p className="text-sm text-[#666666]">
              Mercerization greatly improves the luster, color saturation, and
              tear strength of knitted cotton fabric. Manufacturers primarily
              utilize this fabric in crafting high-end business T-shirts and
              polo shirts. Mercerization greatly improves the luster, color
              saturation, and tear strength of knitted cotton fabric.
              Manufacturers primarily utilize this fabric in crafting high-end
              business T-shirts and polo shirts. Mercerization greatly improves
              the luster, color saturation, and tear strength of knitted cotton
              fabric. Manufacturers primarily utilize this fabric in crafting
              high-end business T-shirts and polo shirts.
            </p>
            <div className="mt-4 text-[#666666] flex flex-row">Color</div>
            <div className="flex flex-row space-x-2 items-center">
              <img src="/Colour.png" alt="" className="w-4 h-4" />
              <span>Customizable - All pantone shades</span>
            </div>
            <div className="container mx-auto mt-6 md:mt-12">
              <button className="w-full bg-transparent border-2 border-[#465B83] text-[#000000]  rounded-full">
                Get a sample Fabric
              </button>
            </div>
          </div>
        </div>
        {/* Image Gallery end */}
        {/* product spec start */}
        <div className="mt-10  md:px-6 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-3  font-brygada">
          {fabricData.map((item, index) => (
            <div
              key={index}
              className="flex flex-row items-center bg-white pl-0 pr-0 md:pl-4 md:pr-4 p-3  space-x-1 w-full"
            >
              <div className="flex-none  pr-2 ">
                <img
                  src={item.iconUrl}
                  alt={`${item.topic} Icon`}
                  className="h-12 w-12"
                />
              </div>
              <div className="flex-grow   flex flex-col items-start justify-between">
                <div className="font-bold text-[#242424]">{item.topic}</div>
                {item.contentArray.length > 1 ? (
                  <div className="relative w-full text-[#6B6B6B]">
                    <button
                      onClick={() => toggleDropdown(index)}
                      className="text-black  mt-1 w-full flex flex-row text-left relative"
                    >
                      {item.contentArray[0]}
                      <span className="relative ml-2 mt-1">
                        <svg
                          className="w-4 h-4 fill-current"
                          viewBox="0 0 20 20"
                        >
                          <path d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" />
                        </svg>
                      </span>
                    </button>
                    {openDropdownIndex === index && (
                      <ul className="origin-top absolute mt-1 w-full bg-white shadow-lg rounded-md overflow-hidden z-10">
                        {item.contentArray.map((content, idx) => (
                          <li
                            key={idx}
                            className="p-2 hover:bg-gray-100 cursor-pointer text-left"
                          >
                            {content}
                          </li>
                        ))}
                      </ul>
                    )}
                  </div>
                ) : (
                  <div className="mt-1 text-left w-full">
                    {item.contentArray[0]}
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>
        {/* product spec end */}
        {/* Fabric composition/blends start */}
        <div className="mt-5 mb-2 text-[#242424] flex items-center justify-center text-2xl">
          Our Pique Knit Fabric Composition
        </div>
        <div className="text-[#757575] flex items-center justify-center mb-5 text-sm">
          Discover our exceptional range of knit fabrics, perfect for quality
          and style. For custom options, feel free to contact us.
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 p-4">
          {contentArray.map((item, index) => (
            <div key={index} className="flex flex-col items-center bg-white ">
              <img
                src={item.imageUrl}
                alt={`Description ${index + 1}`}
                className=" w-[90%]  object-cover  rounded-lg h-[55vh]" // Ensuring the image covers the div and has rounded top corners
              />
              <div className="p-4">{item.content}</div>
            </div>
          ))}
        </div>
        {/* Fabric composition/blends end */}
        {/* More about the fabric start */}
        <div className="flex flex-wrap">
          {array.map((item, index) => (
            <React.Fragment key={index}>
              {/* Determine column order based on index for larger screens */}
              <div
                className={`w-full md:flex md:space-y-12 md:space-x-3 ${
                  index % 2 === 0 ? "md:flex-row-reverse" : "md:flex-row"
                }`}
              >
                {/* Image container */}
                <div className="w-full md:w-1/2 md:flex md:items-center md:justify-center">
                  <img
                    src={item.Image}
                    alt="Fabric"
                    className="w-[90%] h-[35vh] object-fit"
                  />
                </div>
                {/* Content container */}
                <div className="w-full md:w-1/2 flex text-left p-4">
                  {item.Content}
                </div>
              </div>
            </React.Fragment>
          ))}
        </div>

        {/* More about the fabric end */}
        {/* Discover more start */}
        <div className="mt-5 mb-2 text-[#242424] flex items-center justify-center text-2xl">
          Our Pique Knit Fabric Composition
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 p-4">
          {contentArray1.map((item, index) => (
            <div key={index} className="flex flex-col items-center bg-white ">
              <img
                src={item.imageUrl}
                alt={`Description ${index + 1}`}
                className=" w-[90%]  object-cover  rounded-lg h-[55vh]" // Ensuring the image covers the div and has rounded top corners
              />
              <div className="p-4">{item.content}</div>
            </div>
          ))}
        </div>
        {/* Discover more end */}
      </div>
      <FooterCatalogue />
    </div>
  );
}

function ImageGallery() {
  // Product showcase start
  // Sample images
  const images = [
    "https://media.istockphoto.com/id/1461816749/photo/a-crowd-of-people-with-raised-arms-during-a-music-concert-with-an-amazing-light-show-black.jpg?s=612x612&w=0&k=20&c=-hdWCLDP5AI9A3mjq3JPMPKhXxJ2P1iItPDFktQHxX8=",
    "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSqOVoASIrh9O0nBleaRqmP0ramt5YA74bFog&s",
    "https://media.istockphoto.com/id/2167996762/photo/flamingos-on-lake.jpg?s=612x612&w=0&k=20&c=avAsnt588cM2KjWah7F0M9-h17QhUzfJnOnpGlObQyk=",
    // "https://media.istockphoto.com/id/2163630620/photo/abstract-minimalist-product-display-with-pink-smoke-and-wooden-branches.jpg?s=612x612&w=0&k=20&c=7xE-NrqmR5ZWFzqaVnB9xazub1L9Z-4PU5FZlCHvcyU=",
    // "https://media.istockphoto.com/id/2171497774/photo/floating-bubbles-from-the-portal.jpg?s=612x612&w=0&k=20&c=SxnXY6XXftdTaAK-NSm6YSGnf7uEXhk8VcqDBgfWC6Y=",
  ];

  const [selectedIndex, setSelectedIndex] = useState(0);
  const [startIndex, setStartIndex] = useState(0);
  const THUMBNAILS_PER_VIEW = 3;

  const handlePrev = () => {
    if (startIndex > 0) {
      setStartIndex((prev) => prev - 1);
    }
  };

  const handleNext = () => {
    if (startIndex + THUMBNAILS_PER_VIEW < images.length) {
      setStartIndex((prev) => prev + 1);
    }
  };

  // Check if there are 3 or fewer images
  const isThreeOrFewerImages = images.length <= 3;

  // Product showcase end

  return (
    <div className="h-full">
      <div className="flex h-full">
        {/* Thumbnail Column (Left side) */}
        <div className="flex flex-col items-center  pl-6 pr-4 h-full">
          {/* Up Arrow */}
          {!isThreeOrFewerImages && (
            <button
              onClick={handlePrev}
              disabled={startIndex === 0}
              className="disabled:opacity-50"
            >
              {/* &#9650;  */}
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <path d="M18 15l-6-6-6 6" />
              </svg>
            </button>
          )}

          {/* Thumbnails */}
          <div
            className={`flex flex-col overflow-hidden ${
              isThreeOrFewerImages ? "justify-center h-[95%]" : "h-[95%]"
            }`}
          >
            {images
              .slice(startIndex, startIndex + THUMBNAILS_PER_VIEW)
              .map((imgUrl, i) => {
                const actualIndex = startIndex + i;
                return (
                  <img
                    key={imgUrl}
                    src={imgUrl}
                    alt={`Thumbnail ${i}`}
                    onClick={() => setSelectedIndex(actualIndex)}
                    className={`w-20 h-20 object-cover cursor-pointer  mb-2 rounded-xl border 
                  ${
                    selectedIndex === actualIndex
                      ? "border-blue-500"
                      : "border-transparent"
                  }
                `}
                  />
                );
              })}
          </div>

          {/* Down Arrow */}
          {!isThreeOrFewerImages && (
            <button
              onClick={handleNext}
              disabled={startIndex + THUMBNAILS_PER_VIEW >= images.length}
              className=" disabled:opacity-50"
            >
              {/* &#9660;  */}
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <path d="M6 9l6 6 6-6" />
              </svg>
            </button>
          )}
        </div>

        {/* Main Image */}
        <div className="flex-1 h-full">
          <img
            src={images[selectedIndex]}
            alt="Selected main"
            className="w-full h-full object-cover rounded-md shadow-md"
          />
        </div>
      </div>
    </div>
  );
}

function ImageGallery1() {
  // Sample images
  const images = [
    "https://media.istockphoto.com/id/1461816749/photo/a-crowd-of-people-with-raised-arms-during-a-music-concert-with-an-amazing-light-show-black.jpg?s=612x612&w=0&k=20&c=-hdWCLDP5AI9A3mjq3JPMPKhXxJ2P1iItPDFktQHxX8=",
    "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSqOVoASIrh9O0nBleaRqmP0ramt5YA74bFog&s",
    "https://media.istockphoto.com/id/2167996762/photo/flamingos-on-lake.jpg?s=612x612&w=0&k=20&c=avAsnt588cM2KjWah7F0M9-h17QhUzfJnOnpGlObQyk=",
    "https://media.istockphoto.com/id/2163630620/photo/abstract-minimalist-product-display-with-pink-smoke-and-wooden-branches.jpg?s=612x612&w=0&k=20&c=7xE-NrqmR5ZWFzqaVnB9xazub1L9Z-4PU5FZlCHvcyU=",
    "https://media.istockphoto.com/id/2171497774/photo/floating-bubbles-from-the-portal.jpg?s=612x612&w=0&k=20&c=SxnXY6XXftdTaAK-NSm6YSGnf7uEXhk8VcqDBgfWC6Y=",
  ];

  const [selectedIndex, setSelectedIndex] = useState(0);
  const [startIndex, setStartIndex] = useState(0);
  const THUMBNAILS_PER_VIEW = 4;

  const handlePrev = () => {
    if (startIndex > 0) {
      setStartIndex((prev) => prev - 1);
    }
  };

  const handleNext = () => {
    if (startIndex + THUMBNAILS_PER_VIEW < images.length) {
      setStartIndex((prev) => prev + 1);
    }
  };

  // Check if there are more thumbnails to scroll
  const hasMoreThumbnails = images.length > THUMBNAILS_PER_VIEW;

  // Check if the left arrow is active
  const isLeftArrowActive = startIndex > 0;
  // Check if the right arrow is active
  const isRightArrowActive = startIndex + THUMBNAILS_PER_VIEW < images.length;

  return (
    <div className="h-[65vh] w-full">
      <div className="flex flex-col h-full w-full">
        {/* Main Image */}
        <div className="flex-1 h-[70%] w-full mb-4">
          <img
            src={images[selectedIndex]}
            alt="Selected main"
            className="w-full h-full object-cover rounded-md shadow-md"
          />
        </div>

        {/* Thumbnail Row (Horizontal) */}
        <div className="flex items-center justify-center mt-4 w-full h-[10vh] relative">
          {/* Left Arrow */}
          {hasMoreThumbnails && (
            <button
              onClick={handlePrev}
              disabled={!isLeftArrowActive}
              className={`absolute left-0 z-10 ${
                isLeftArrowActive ? "text-black" : "text-gray-400"
              }`}
              style={{ width: "5%" }}
            >
              {/* &#9664;  */}
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <path d="M15 18l-6-6 6-6" />
              </svg>
            </button>
          )}

          {/* Thumbnails */}
          <div
            className="flex items-center justify-start overflow-x-hidden w-[90%] mx-auto"
            style={{
              scrollBehavior: "smooth",
            }}
          >
            {images
              .slice(startIndex, startIndex + THUMBNAILS_PER_VIEW)
              .map((imgUrl, i) => {
                const actualIndex = startIndex + i;
                return (
                  <img
                    key={imgUrl}
                    src={imgUrl}
                    alt={`Thumbnail ${i}`}
                    onClick={() => setSelectedIndex(actualIndex)}
                    className={`ml-2 w-1/4 h-12 object-cover cursor-pointer mx-1 rounded-xl border 
                  ${
                    selectedIndex === actualIndex
                      ? "border-blue-500"
                      : "border-transparent"
                  }
                `}
                  />
                );
              })}
          </div>

          {/* Right Arrow */}
          {hasMoreThumbnails && (
            <button
              onClick={handleNext}
              disabled={!isRightArrowActive}
              className={`ml-3 absolute right-0 z-10 ${
                isRightArrowActive ? "text-black" : "text-gray-400"
              }`}
              style={{ width: "5%" }}
            >
              {/* &#10145;  */}
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <path d="M9 18l6-6-6-6" />
              </svg>
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
